export default {"src":"/_next/static/media/cookware.0d549e8c.svg","height":100,"width":100};